import { render, staticRenderFns } from "./BanClients.vue?vue&type=template&id=cbb2400a"
import script from "./BanClients.vue?vue&type=script&lang=js"
export * from "./BanClients.vue?vue&type=script&lang=js"
import style0 from "./BanClients.vue?vue&type=style&index=0&id=cbb2400a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports